import React from 'react';
import styled from '@emotion/styled';
import { Icon, NakedButton, Text } from '@qga/roo-ui/components';
import { format } from 'date-fns';

export type DatesProps = {
  onClick: () => void;
  departureDate: string | undefined;
  returnDate: string | undefined;
};

const DatesButton = styled(NakedButton)`
  display: flex;
  align-items: center;
`;

const Dates = ({ onClick, departureDate, returnDate }: DatesProps) => {
  const returnDateObj = returnDate ? new Date(returnDate) : undefined;
  const departureDateObj = departureDate ? new Date(departureDate) : undefined;

  if (!returnDateObj || !departureDateObj) {
    return null;
  }

  return (
    <DatesButton onClick={onClick} mb="2" mt="1">
      <Text fontSize="sm" textDecoration="underline" color="text.body">
        {format(departureDateObj, 'd MMM')} - {format(returnDateObj, 'd MMM')}
      </Text>
      <Icon name="modeEdit" size={16} ml="1" />
    </DatesButton>
  );
};

export default Dates;
